<script setup lang="ts">
import UniversalPrintWorkspace from "@/components/healthcare/print/UniversalPrintWorkspace.vue";

definePage({
  meta: {
    navActiveLink: "healthcare-clinical-master-data-print",
    permissionKey: "page.healthcare.clinical_master_data",
  },
});
</script>

<template>
  <UniversalPrintWorkspace />
</template>
